"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventTypes = _interopRequireDefault(require("../../enum/EventTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// 是否发送过
var sent = false;

function init(scout) {
  function pageOpen() {
    // 发送过直接返回不再上报
    if (sent) {
      return;
    }

    try {
      var duration = Date.now() - window.performance.timing.navigationStart;
      scout.track(_EventTypes["default"].PAGE_OPEN, {
        duration: duration
      }); // 置为true

      sent = true;
    } catch (e) {
      console.log(e);
    }
  }

  scout.pageOpen = pageOpen;
}

var _default = {
  init: init,
  name: 'pageOpen'
};
exports["default"] = _default;